var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"external-link",attrs:{"href":_vm.href,"target":"_blank"}},[_c('no-drag-image',{attrs:{"src":require("@/assets/icons/link-icon.png")}}),_c('span',[_vm._v(_vm._s(_vm.label || _vm.href))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }